module.exports = __webpack_public_path__ + "img/liveabc_logo.c5a831d2.png";